import React from 'react'
import { IntlProvider, addLocaleData } from 'react-intl'
import en from 'react-intl/locale-data/en'
import fr from 'react-intl/locale-data/fr'

addLocaleData(en)
addLocaleData(fr)

let messages
let locale = window.navigator.languages ? window.navigator.languages[0] :
        (window.navigator.language || window.navigator.userLanguage);

try {
  messages = require(`public/messages/${locale}`)
} catch(e) {
  messages = require('public/messages/en-US')
    console.log('no fiie')
}

exports.wrapRootComponent = (Root) => {
  const Wrapper = () => (
    <IntlProvider locale={locale} messages={messages}>
      <Root />
    </IntlProvider>
  )
  return Wrapper
}



// WEBPACK FOOTER //
// ../gatsby-browser.js